import { BrowserRouter, Route, Routes } from "react-router-dom";
import Sidebar from "./components/Sidebar";
// import FAQs from './pages/FAQs.jsx';
import "./MediaQuery.css";
// import TermsMarch from "./pages/TermsMarch.jsx";
// import Term1 from './pages/Term1.jsx';
// import TermsUpdate from './pages/TermsJuly.jsx';
import Accordion from "./pages/Accordion.js";
// import TermsMay from "./pages/TermsMay.jsx";
import TermsJune from "./pages/TermsJune_19.jsx";

const App = () => {
  return (
    // <div className='wrapper'>
    //             <Accordion />
    //           </div>

    <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
      <div className="App">
        {/* <Sidebar> */}
        <Routes>
          {/* <Route index path="/thunderwheels/tandc" element={<TermsMay />} /> */}
          <Route index path="/thunderwheels/tandc" element={<TermsJune />} />
          {/* <Route path="/" element={<Terms />} /> */}
          {/* <Route index path="/thunderwheels/tandc" element={<TermsMarch />} /> */}
          {/* <Route index path="/privacy-policy" element={<Privacy />} /> */}
          {/* <Route path="/tandc" element={<TermsUpdate />} /> */}
          {/* <Route path="/faqs" element={<FAQs />} /> */}
          <Route path="/thunderwheels/faqs" element={<Accordion />} />
        </Routes>
        {/* </Sidebar> */}
      </div>
    </BrowserRouter>
  );
};

export default App;
